<template>
    <div
        v-show="isVisible"
        class="toast"
        role="status"
        aria-live="polite"
        aria-atomic="true"
    >
        <div class="visually-hidden">
            {{ message }}
        </div>
    </div>
</template>

<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
    message: {
        type: String,
        required: true,
    },
    duration: {
        type: Number,
        default: 3000,
    },
    id: {
        type: String,
        required: true,
    },
});

let timeoutId = null;

const emit = defineEmits(['dismiss']);
const isVisible = ref(false);

const show = () => {
    isVisible.value = true;

    if (props.duration > 0) {
        timeoutId = setTimeout(() => {
            dismiss();
        }, props.duration);
    }
};

const dismiss = () => {
    isVisible.value = false;
    
    if (timeoutId) {
        clearTimeout(timeoutId);
    }
    emit('dismiss', props.id);
};

watch(
    () => props.message,
    () => {
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
        show();
    },
    { immediate: true }
);

defineExpose({
    dismiss,
});

</script>

